import { render } from "./Tornei.vue?vue&type=template&id=69a6f1a4&scoped=true"
import script from "./Tornei.vue?vue&type=script&lang=js"
export * from "./Tornei.vue?vue&type=script&lang=js"

import "./Tornei.vue?vue&type=style&index=0&id=69a6f1a4&lang=css"
import "./Tornei.vue?vue&type=style&index=1&id=69a6f1a4&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a6f1a4"]])

export default __exports__